module.exports = __webpack_public_path__ + "img/Startbild-02.eab2a8a6.png";